module.exports = __webpack_public_path__ + "assets/images/copo_83ef51f72be10f3eff82e1225273ccfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cilindro/copo.png
// module id = 187
// module chunks = 0